module.exports = __webpack_public_path__ + "static/img/2023.11d330c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023.jpg
// module id = 313
// module chunks = 0